import { defineStore } from "pinia";
import { NoiQuyApi } from "@/services/noiQuyService";
import { useToast } from "vue-toastification";

const toast = useToast();

export const useNoiQuyStore = defineStore("noiQuy", {
    state: (loai) => ({
        isLoading: false,
        error: null,
        items: [],

        // Paging
        page: 0,
        size: 10,
        sort: "id,desc", // Mặc định sort theo ID giảm dần
        totalPages: 1,
        totalElements: 0,

        // Filters
        filterPhongBanId: null,
        filterChung: null, // (true = chung, false = riêng, null = tất cả)
        filterLoai: null
    }),

    getters: {
        currentPage(state) {
            return state.page + 1;
        },
    },

    actions: {
        setPage(p1) {
            const p0 = Math.max(0, p1 - 1);
            if (p0 !== this.page) this.page = p0;
        },
        setSize(s) {
            this.size = s;
            this.page = 0;
        },
        setFilters({ phongBanId, chung, loai}) {
            this.filterPhongBanId = phongBanId;
            this.filterChung = chung;
            this.filterLoai = loai;
            this.page = 0; // Reset về trang đầu khi lọc
        },

        async fetchList() {
            this.isLoading = true;
            this.error = null;
            try {
                const params = {
                    page: this.page,
                    size: this.size,
                    sort: this.sort,
                    phongBanId: this.filterPhongBanId,
                    chung: this.filterChung,
                    loai: this.filterLoai,
                };

                const data = await NoiQuyApi.list(params);
                
                this.items = data.data.content || [];
                this.totalPages = data.data.totalPages ?? 1;
                this.totalElements = data.data.totalElements ?? this.items.length;
                this.page = data.data.number ?? 0;
                this.size = data.data.size ?? this.size;
            } catch (e) {
                const errorMsg = e?.response?.data?.message || e?.message || "Lỗi tải danh sách nội quy";
                this.error = errorMsg;
                toast.error(errorMsg);
            } finally {
                this.isLoading = false;
            }
        },

        async deleteNoiQuy(id) {
            if (!confirm('Bạn có chắc chắn muốn xóa nội quy này?')) return;
            
            try {
                await NoiQuyApi.remove(id);
                toast.success('Xóa nội quy thành công!');
                // Nếu xóa item cuối cùng của trang > 1, lùi về 1 trang
                if (this.items.length === 1 && this.page > 0) {
                    this.page -= 1;
                }
                await this.fetchList();
            } catch (e) {
                 const errorMsg = e?.response?.data?.message || e?.message || "Lỗi khi xóa nội quy";
                 toast.error(errorMsg);
            }
        },
    },
});